import styled from 'styled-components';

export const StyledWorkerManagementLists = styled.div`
  display: flex;
  flex-direction: column;
  height: 90%;

  .table {
    overflow: hidden;
    max-height: 1000px;
    min-height: 375px;

    > div {
      height: 100%;

      > .MuiTableContainer-root {
        height: 80%;
      }
    }
  }
`;

export const StyledUserInfoModal = styled.div`
  .modalBody {
    padding: 28px;

    .modalGroup {
      margin-top: 17px;

      span {
        margin-bottom: 17px;
      }
    }
  }
`;
